import { AudioFormat, } from '@zattoo/playback-sdk';
export const setMediaTrackById = (nextTrackId, tracks, setTrack) => {
    const targetTrack = tracks?.find((track) => track.id === nextTrackId);
    if (!targetTrack) {
        return;
    }
    setTrack?.(targetTrack);
};
export const updatePlayOptions = (playOptions, isCastEnabled) => {
    const { startPositionMs, ...originalPlayOptions } = playOptions;
    const updatedPlayOptions = { ...originalPlayOptions };
    if (playOptions.programStartEpochMs && playOptions.programEndEpochMs) {
        updatedPlayOptions.program = {
            start: playOptions.programStartEpochMs,
            duration: playOptions.programEndEpochMs - playOptions.programStartEpochMs,
        };
    }
    if (startPositionMs !== undefined) {
        updatedPlayOptions.startupPosition = startPositionMs / 1000;
    }
    if (isCastEnabled !== undefined) {
        updatedPlayOptions.castEnabled = isCastEnabled;
    }
    return updatedPlayOptions;
};
const getDolbyName = (languageNames, currentLocale = 'en') => {
    if (!languageNames) {
        return undefined;
    }
    return languageNames['ec-3']?.[currentLocale];
};
export const getISOLanguageName = (track, languageNames, currentLocale = 'en') => {
    const languageCode = track.locale;
    let dolbyLabel = '';
    if (!languageCode || !languageNames) {
        return undefined;
    }
    if (track.audioFormat === AudioFormat.DOLBY) {
        dolbyLabel = getDolbyName(languageNames, currentLocale) ?? ' - Dolby';
    }
    const result = languageNames[languageCode]?.[currentLocale]
        ?? `${languageNames.default?.[currentLocale]} (${languageCode})`;
    return `${result}${dolbyLabel}`;
};
export const imaCuePointsToUTVCueRanges = (cuePoints = [], preMs = 0) => {
    return cuePoints
        // filter out preroll (0 value) and post roll (-1 value)
        .filter((cuePoint) => cuePoint.start !== 0 && cuePoint.start !== -1)
        .map((cuePoint) => {
        return {
            startMs: (cuePoint.start * 1000) - preMs,
            endMs: cuePoint.end ? (cuePoint.end * 1000) - preMs : null,
        };
    });
};
